import { createSlice } from '@reduxjs/toolkit'

import { Hash } from 'types/entities'

import { RPC_LIST, SupportedChainId } from 'constants/chains'

import { TransactionsHistory, Setting, Settings } from './types'

export interface ApplicationState {
  settings: Settings
  privateKey: Hash | null
  isPKSaved: boolean
  transactionsHistory: TransactionsHistory
}

const initialState: ApplicationState = {
  isPKSaved: false,
  privateKey: null,
  transactionsHistory: {},
  settings: {
    [Setting.IS_SIGNED]: false,
    [Setting.IS_MAX_APPROVE]: true,
    [Setting.SHOW_ADDRESS_GENERATOR]: false,
    [Setting.LANGUAGE]: 'eng', // ToDo add logic
    [Setting.RPC_URL]: RPC_LIST[SupportedChainId.MAINNET],
  },
}

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPrivateKey: (state, action) => {
      state.privateKey = action.payload
    },
    updateTransaction: (state, action) => {
      state.transactionsHistory[action.payload.txHash] = action.payload
    },
    updateSetting: (state, action) => {
      state.settings = { ...state.settings, [action.payload.key]: action.payload.value }
    },
    setIsPKSaved: (state) => {
      state.isPKSaved = !state.isPKSaved
    },
    clearPKWallet: (state) => {
      state.isPKSaved = false
      state.privateKey = null
    },
    userClearState: () => initialState,
  },
})

export const { updateSetting, setPrivateKey, userClearState, updateTransaction, setIsPKSaved, clearPKWallet } =
  user.actions

export default user.reducer
